import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from 'services/api';

export const fetchSystemInfo = createAsyncThunk('systemInfo/fetchSystemInfo', async () => {
  const response = await api.get('/system_info');
  return response.data;
});

const systemInfoSlice = createSlice({
  name: 'systemInfo',
  initialState: {
    version: null as string | null,
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSystemInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.version = action.payload.version;
      })
      .addCase(fetchSystemInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch system info';
      });
  },
});

export default systemInfoSlice.reducer;
